




























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactLensImageTypeSwitcher from './ContactLensImageTypeSwitcher.vue'

const HEADER_SELECTOR = '#vue-ec-header'
const HINT_DISMISSED_KEY = 'contactLensImageTypeSwitcherHintDismissed'

/**
 * ContactLensImageTypeSwitcher 専用の固定表示コンポーネント
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/8656
 */
@Component({ components: { ContactLensImageTypeSwitcher } })
export default class ContactLensImageTypeSwitcherFloat extends Vue {
  // 監視対象のコンテナ要素
  @Prop({ required: true })
  container: Element

  // コンテナの上端がビューポートより上かつ下端がビューポート内にあるか
  isInView: boolean = false

  // ヘッダー（ #vue-ec-header ）の高さ（固定位置の top オフセット）
  headerHeight: number = 0

  // 親コンポーネントの左端位置と横幅
  containerLeft: number = 0
  containerWidth: number = 0

  showHint: boolean = false

  // ResizeObserver は TypeScript 3.x の dom lib 未収録のため any で定義
  private resizeObserver: any = null

  dismissHint() {
    this.showHint = false
    localStorage.setItem(HINT_DISMISSED_KEY, '1')
  }

  mounted() {
    this.showHint = localStorage.getItem(HINT_DISMISSED_KEY) !== '1'
    this.updateHeaderHeight()
    this.updateContainerRect()
    this.updateVisibility()

    window.addEventListener('scroll', this.handleScroll, { passive: true })

    if ('ResizeObserver' in window) {
      this.resizeObserver = new (window as any).ResizeObserver(() => {
        this.updateHeaderHeight()
        this.updateContainerRect()
      })
      const header = document.querySelector(HEADER_SELECTOR)
      if (header) {
        this.resizeObserver.observe(header)
      }
      if (this.container) {
        this.resizeObserver.observe(this.container)
      }
    }
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  private handleScroll() {
    this.updateVisibility()
  }

  private updateVisibility() {
    if (!this.container) {
      this.isInView = false

      return
    }
    const rect = (this.container as HTMLElement).getBoundingClientRect()
    this.isInView = rect.top < this.headerHeight && rect.bottom > this.headerHeight
  }

  private updateHeaderHeight() {
    const header = document.querySelector(HEADER_SELECTOR)
    this.headerHeight = header ? (header as HTMLElement).offsetHeight : 0
  }

  private updateContainerRect() {
    if (!this.container) return
    const rect = (this.container as HTMLElement).getBoundingClientRect()
    this.containerLeft = rect.left
    this.containerWidth = rect.width
  }
}
